<template>
  <b-form @submit.prevent="handleFormSubmit">
    <b-row>
      <b-col sm="12">
        <b-form-group :label="$t('register.firstNameLabel')" class="text-left label">
          <b-form-input type="text" :placeholder="$t('register.firstNamePlaceholder')" class="input" required
            v-model="user.first_name"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="12">
        <b-form-group :label="$t('register.lastNameLabel')" class="text-left label">
          <b-form-input type="text" :placeholder="$t('register.lastNamePlaceholder')" class="input" required
            v-model="user.last_name"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group :label="$t('register.emailLabel')" label-for="input-1" class="text-left label text-capitalize">
      <b-form-input type="email" class="mb-3 input" :placeholder="$t('register.emailPlaceholder')" required
        v-model="user.email" disabled></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('register.phoneNumberLabel')" label-for="input-1" class="text-left label text-capitalize">
      <b-input-group size="lg" class="w-100" prepend="+1">
        <b-form-input v-mask="phoneMask" class="f-14" v-model="user.phone_number" required></b-form-input>
      </b-input-group>
      <p v-if="errors && errors.phone" class="field-error pb-2">
        {{ errors.phone[0] }}
      </p>
    </b-form-group>

    <b-form-group :label="$t('register.passwordLabel')" class="text-left label password password-2">
      <b-form-input class="input" :placeholder="$t('register.passwordPlaceholder')" required
        :type="showPassword1 ? 'text' : 'password'" v-model="user.password1"></b-form-input>
      <b-icon :icon="showPassword1 ? 'eye-fill' : 'eye-slash-fill'" @click="showPassword1 = !showPassword1"></b-icon>
    </b-form-group>

    <b-form-group :label="$t('register.confirmPasswordLabel')" class="text-left label password password-2">
      <b-form-input class="input" :placeholder="$t('register.confirmPasswordPlaceholder')" required
        :type="showPassword2 ? 'text' : 'password'" v-model="user.password2"></b-form-input>
      <b-icon :icon="showPassword2 ? 'eye-fill' : 'eye-slash-fill'" @click="showPassword2 = !showPassword2"></b-icon>
    </b-form-group>
    <b-button type="submit" class="w-100 mt-3 login h-40px" variant="primary">{{ $t('register.next') }}</b-button>
  </b-form>
</template>
<script>
import { checkPhoneFormat } from '../../../services/helper';
export default {
  data() {
    return {
      checkPhoneFormat,
      showPassword1: false,
      showPassword2: false,
      errors: {}
    }
  },
  name: "Step2",
  props: ['user', 'onSignUp'],
  computed: {
    phoneMask() {
      return this.user?.phone_number?.length > 0
        ? [
          /\d/, /\d/, /\d/, " ",
          /\d/, /\d/, /\d/, " ",
          /\d/, /\d/, /\d/, /\d/
        ]
        : false; // Allows empty input
    },
  },
  methods: {
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },
    handleFormSubmit() {
      try {
        this.errors = {};

        if (this.user.phone_number) {
          if (!this.checkPhoneFormat(this.user.phone_number)) {
            throw {
              phone: [this.$t('register.wrongFormat')],
            };
          }
        }
        this.onSignUp()

      } catch (error) {
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
        }
      }
    }
  }
}
</script>